"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPageFieldConfig = exports.defaultIndexLanguageConfig = exports.defaultDiacriticsConfig = exports.defaultAlgoliaIndexConfig = void 0;
exports.defaultAlgoliaIndexConfig = {
    minWordSizefor1Typo: 5,
    minWordSizefor2Typos: 10,
    hitsPerPage: 20,
    maxValuesPerFacet: 100,
    ignorePlurals: false,
    advancedSyntax: true,
    distinct: true,
    unretrievableAttributes: [
        'contents', 'distinctHash'
    ],
    paginationLimitedTo: 1000,
    attributeForDistinct: 'distinctHash',
    exactOnSingleWordQuery: 'attribute',
    removeWordsIfNoResults: 'allOptional',
    queryType: 'prefixLast',
    typoTolerance: 'strict',
    alternativesAsExact: [
        'ignorePlurals',
        'singleWordSynonym'
    ],
    enableReRanking: true,
    reRankingApplyFilter: []
};
exports.defaultDiacriticsConfig = {
    de: 'üöäß'
};
const defaultIndexLanguageConfig = (language) => {
    var _a;
    return {
        removeStopWords: [
            language
        ],
        queryLanguages: [
            language
        ],
        keepDiacriticsOnCharacters: (_a = exports.defaultDiacriticsConfig[language]) !== null && _a !== void 0 ? _a : '',
        indexLanguages: [
            language
        ]
    };
};
exports.defaultIndexLanguageConfig = defaultIndexLanguageConfig;
exports.defaultPageFieldConfig = {
    searchableAttributes: [
        'unordered(category)',
        'unordered(name)',
        'unordered(description)',
        'unordered(keywords)',
        'unordered(occasions)',
        'contents.page'
    ],
    decompoundedAttributes: {
        de: [
            'category',
            'description',
            'name'
        ]
    },
    attributesForFaceting: [
        'category',
        'occasions',
        'ids.globalName'
    ],
    disableTypoToleranceOnAttributes: [
        'contents.page'
    ],
    ranking: [
        'typo',
        'geo',
        'words',
        'filters',
        'proximity',
        'attribute',
        'exact',
        'custom'
    ],
    customRanking: [
        'desc(weightInCategory)'
    ],
    reRankingApplyFilter: []
};
